module.exports = __webpack_public_path__ + "media/site_templates/www.pest-control.business/images/our_services_1-d460fdf4f6ffed65da89cbcdc2ef6e41.jpg";